import type { SymbolKey } from '@/entities/symbol';
import { isEmptySymbol } from '@/entities/symbol';

type RowWithSymbols = {
  symbol: { key: SymbolKey };
  diffSymbol: { key: SymbolKey };
};

export function getSymbolsFromRow(row: RowWithSymbols): SymbolKey[] {
  return [row.symbol.key, row.diffSymbol.key].filter(symbol => !isEmptySymbol(symbol));
}

export function getSymbolsFromRows(rows: readonly RowWithSymbols[]): SymbolKey[] {
  return rows.flatMap(getSymbolsFromRow);
}
